import styles from "./BottomSlideBar.module.css";
import bitcoin from "../../images/bitcoin.svg";
import cld from "../../cloudinary";
import OwlCarousel from "react-owl-carousel2";
import { AdvancedImage } from "@cloudinary/react";
import { thumbnail } from "@cloudinary/url-gen/actions/resize";
import { useSelector } from "react-redux";
import "react-owl-carousel2/lib/styles.css";
import "react-owl-carousel2/src/owl.theme.default.css";
import { useDispatch } from "react-redux";
import { updateActiveImage } from "../../store/actions";

export default function BottomSlideBar() {
  const dispatch = useDispatch();
  const activeCelebData = useSelector((state) => state.activeCelebData);
  const activeImage = useSelector((state) => state.activeImage);
  const options = {
    margin: 10,
    loop: false,
    dots: false,
    autoplay: false,
    nav: true,
    navText: [
      "<svg xmlns='http://www.w3.org/2000/svg' style='transform:rotate(180deg)' viewBox='0 0 20 20' width='35px' height='35px' fill='#fff' x='0px' y='0px'><g><path d='M12.96094,10a.49966.49966,0,0,1-.14649.35352L7.89258,15.2749a.49995.49995,0,1,1-.707-.707L11.75391,10,7.18555,5.43213a.49995.49995,0,0,1,.707-.707l4.92187,4.92138A.49966.49966,0,0,1,12.96094,10Z'></path></g></svg>",
      "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' width='35px' height='35px' fill='#fff' x='0px' y='0px'><g><path d='M12.96094,10a.49966.49966,0,0,1-.14649.35352L7.89258,15.2749a.49995.49995,0,1,1-.707-.707L11.75391,10,7.18555,5.43213a.49995.49995,0,0,1,.707-.707l4.92187,4.92138A.49966.49966,0,0,1,12.96094,10Z'></path></g></svg>",
    ],
    responsive: {
      0: {
        items: 3,
      },
      576: {
        items: 5,
      },
      768: {
        items: 6,
      },
      991: {
        items: 7,
      },
      1200: {
        items: 9,
      },
      1900: {
        items: 10,
      },
    },
  };
  return (
    <section className={`bottom-slide ${styles.bottomSlide}`}>
      <OwlCarousel options={options}>
        {activeCelebData.map((item, index) => (
          <div
            className={`${activeImage === index ? styles.custActive : ""} ${
              styles.singleSlide
            }`}
            key={index}
            onClick={() => dispatch(updateActiveImage(index))}
          >
            <AdvancedImage
              cldImg={cld
                .image(item.public_id)
                .resize(thumbnail(150, 200).gravity("faces"))}
              className={styles.img}
            />
            <div className={styles.bottomBar}>
              <img
                src={bitcoin}
                alt="Etherium Icon"
                className={styles.iconImg}
              />
              <p className={styles.bottomBarPara}>{item.highestBid} ETH</p>
            </div>
          </div>
        ))}
      </OwlCarousel>
    </section>
  );
}
